import { CollectionsHandlebarsModal } from './components/CollectionsHandlebarsModal';

export default CollectionsHandlebarsModal;
